'use client';
import type {Stack} from '@chakra-ui/react';
import {Circle, StackItem} from '@chakra-ui/react';
import type {ComponentWithAs} from '@chakra-ui/system';
import {forwardRef} from '@chakra-ui/system';
import type {IconDefinition} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {ChakraDiv} from '@linx-security/ui/utils/chakra-elements';
import type {JSX} from 'react';

import {Heading, Text} from '../index';

import {useStyles} from './context';

type Props = {
  title?: string | JSX.Element;
  subtitle?: string | JSX.Element;
  icon?: IconDefinition;
  extra?: JSX.Element;
};

export const WidgetHeader: ComponentWithAs<typeof Stack, Props> = forwardRef(({title, subtitle, icon, extra}, ref) => {
  const {header: style, title: titleStyle, icon: iconStyle} = useStyles();

  return (
    <ChakraDiv sx={style} ref={ref}>
      <StackItem maxW={`full`}>
        {typeof title === `string` ? (
          <Heading sx={titleStyle} size={`sm`}>
            {title}
          </Heading>
        ) : (
          title
        )}
        {typeof subtitle === `string` ? (
          <Text size={`md`} mt={0} variant={`secondary`}>
            {subtitle}
          </Text>
        ) : (
          subtitle
        )}
      </StackItem>
      {icon && (
        <Circle sx={iconStyle}>
          <FontAwesomeIcon icon={icon} color={`brand.light`} />
        </Circle>
      )}
      {extra && extra}
    </ChakraDiv>
  );
});

export type {Props as WidgetHeaderProps};
